/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
import { Api } from '@/services/Api'

export default {
  getRelayData(plantId, blockId, currentTime) {
    return Api().get(`/api/v1.0/sld/relay-data/${plantId}/${blockId}/${currentTime}`)
  },
  getABTData(plantId, currentTime) {
    return Api().get(`/api/v1.0/sld/abt-data/${plantId}/${currentTime}`)
  },
  getAnnunciatorData(plantId, currentTime) {
    return Api().get(`/api/v1.0/sld/annunciator-data/${plantId}/${currentTime}`)
  },
  getMFMData(plantId, blockId, currentTime) {
    return Api().get(`/api/v1.0/sld/mfm-data/${plantId}/${blockId}/${currentTime}`)
  },
  getDataV2(plantId, device, params) {
    return Api().get(`/api/v2/sld/${plantId}/${device}/${params}`).then(res => res.data.message)
  },
  geHoverDataV2(plantId, device, deviceId) {
    return Api().get(`/api/v2/sld/hover/${plantId}/${device}/${deviceId}`).then(res => res.data.message)
  },
  getSymbol(sldId) {
    return Api().get(`/api/v1.0/symbol/${sldId}`).then(res => res.data.message)
  },
  getSVGimage(param) {
    return Api().get(`/api/v1.0/svg/${param}`).then(res => res.data)
  },
  getInvData(plantId, currentTime) {
    return Api().get(`/api/v1.0/sld/inv-data/${plantId}/${currentTime}`)
  },
  getScbData(plantId, currentTime) {
    return Api().get(`/api/v1.0/sld/scb-data/${plantId}/${currentTime}`)
  },
  getZoneData(plantId, currentTime) {
    return Api().get(`/api/v1.0/sld/scb-zone-data/${plantId}/${currentTime}`)
  },
  getMpptData(plantId, currentTime) {
    return Api().get(`/api/v1.0/sld/mppt-data/${plantId}/${currentTime}`)
  },
  getTableData(plantId, deviceId, deviceType) {
    return Api().get(`/api/v1.0/sld/table-data/${plantId}/${deviceId}/${deviceType}`)
  },
  getBreakerData(plantId, currentTime) {
    return Api().get(`/api/v1.0/sld/breaker-data/${plantId}/${currentTime}`)
  }
}
